<template>
  <div>
    <TextField v-if="field.fieldType==='OPEN' && field.isMultiline" :validation-error="validationError" :field="field" @changed="changed"></TextField>
    <TextAreaField v-if="field.fieldType==='OPEN' && !field.isMultiline" :validation-error="validationError" :field="field" @changed="changed"></TextAreaField>
    <ImageField v-if="field.fieldType==='IMAGE'" :field="field" :validation-error="validationError" @changed="changed"></ImageField>
    <RichTextField v-if="field.fieldType==='textarea'" :field="field" :validation-error="validationError" @changed="changed"></RichTextField>
    <SelectField v-if="field.fieldType==='CHOICE'" :field="field" :answers="answers" :validation-error="validationError" @changed="changed"></SelectField>
  </div>
</template>

<script>
import TextField from "./TextField";
import RichTextField from "./RichTextField";
import SelectField from "./SelectField";
import TextAreaField from "@/components/forms/TextAreaField";
import ImageField from "@/components/forms/ImageField";

export default {
  components: {
    ImageField,
    TextAreaField,
    TextField,
    RichTextField,
    SelectField
  },
  props: ['field', 'validationError', 'answers'],
  name: "FieldSwitch",
  methods: {
    changed(val) {
      this.$emit('changed', val);
    }
  }
}
</script>

<style scoped>

</style>
